import type { ImgHTMLAttributes, ReactNode } from "react";

type DeviceMockupProps = {
  src: string;
  alt: string;
  priority?: boolean;
  size?: "hero" | "standard" | "small";
  dark?: boolean;
  children?: ReactNode;
  className?: string;
};

const sizeClass = {
  hero: "w-[clamp(220px,28vw,340px)]",
  standard: "w-[250px] sm:w-[320px] lg:w-[380px]",
  small: "w-[174px] sm:w-[204px] lg:w-[220px]"
};

const dimensions = {
  hero: { width: 1320, height: 2868 },
  standard: { width: 1320, height: 2868 },
  small: { width: 1320, height: 2868 }
};

export function DeviceMockup({ src, alt, priority = false, size = "standard", dark = false, children, className = "" }: DeviceMockupProps) {
  const loading: ImgHTMLAttributes<HTMLImageElement>["loading"] = priority ? "eager" : "lazy";
  const fetchPriorityAttr = { fetchpriority: priority ? "high" : "auto" };

  return (
    <figure className={`device-shell ${dark ? "device-shell-dark" : ""} ${sizeClass[size]} ${className}`}>
      <div className="device-screen">
        <img
          {...fetchPriorityAttr}
          alt={alt}
          decoding="async"
          height={dimensions[size].height}
          loading={loading}
          src={src}
          width={dimensions[size].width}
        />
      </div>
      {children}
    </figure>
  );
}
